import React from 'react';
import { cloneDeep } from 'lodash';
import styled from 'styled-components';
import { ExternalDashboardNotificationsDTO } from 'api/AppExternalController/getDashboardNotifications';
import { Button } from 'components';
import ExternalNotificationToggles from './ExternalNotificationToggles';
import ExternalNotificationDeliveryOptions from './ExternalNotificationDeliveryOptions';

const ExternalNotificationBody = ({
  notificationOptions: {
    notifications,
    email,
    deliveries,
    phone,
    feedbackCollectedExternal,
  },
  setNotificationOptions,
  saveSettings,
  saving,
}: {
  notificationOptions: ExternalDashboardNotificationsDTO;
  setNotificationOptions: React.Dispatch<
    React.SetStateAction<ExternalDashboardNotificationsDTO>
  >;
  saveSettings: () => void;
  saving: boolean;
}) => {
  const toggleNotification = (
    notification: keyof ExternalDashboardNotificationsDTO['notifications'],
  ) =>
    setNotificationOptions(prev => {
      if (notification === 'Feedback Collected') {
        return {
          ...prev,
          feedbackCollectedExternal: !prev.feedbackCollectedExternal,
        };
      }
      return {
        ...prev,
        notifications: {
          ...prev.notifications,
          [notification]: !prev.notifications[notification],
        },
      };
    });

  const toggleEmails = () =>
    setNotificationOptions(prev => ({
      ...prev,
      deliveries: {
        ...prev.deliveries,
        Email: !prev.deliveries.Email,
      },
    }));

  const toggleSms = (index: number) =>
    setNotificationOptions(prev => {
      const phoneCopy = cloneDeep(prev.phone);
      phoneCopy[index].sendSms = !phoneCopy[index].sendSms;

      return {
        ...prev,
        phone: phoneCopy,
      };
    });

  const setPhone = (index: number, newPhone: string) =>
    setNotificationOptions(prev => ({
      ...prev,
      phone: prev.phone.map((p, i) =>
        i === index ? { ...p, number: newPhone } : p,
      ),
    }));

  return (
    <BodyWrapper>
      <div className="row">
        <ExternalNotificationToggles
          feedbackCollectedExternal={feedbackCollectedExternal}
          notifications={notifications}
          toggleNotification={toggleNotification}
        />
        <ExternalNotificationDeliveryOptions
          email={email}
          toggleEmails={toggleEmails}
          deliveries={deliveries}
          phone={phone}
          toggleSms={toggleSms}
          setPhone={setPhone}
        />
      </div>
      <SaveButton onClick={saveSettings} saving={saving} />
    </BodyWrapper>
  );
};

const BodyWrapper: React.FC = ({ children }) => (
  <div className="content transition animated fadeIn">
    <div className="row">
      <div className="col-md-12">
        <div className="hpanel appointment-details">
          <div className="panel-body">{children}</div>
        </div>
      </div>
    </div>
  </div>
);

const SaveButton: React.FC<{ onClick: () => void; saving: boolean }> = ({
  onClick,
  saving,
}) => (
  <div className="row">
    <div className="col-md-9 text-center">
      <hr />
      <StyledButton
        className="btn btn-primary"
        onClick={onClick}
        loading={saving}
      >
        Save
      </StyledButton>
    </div>
  </div>
);

const StyledButton = styled(Button)`
  & > span {
    margin-right: 0px !important;
  }
`;

export default ExternalNotificationBody;
